import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { ConfirmationService } from '../../services/confirmation.service';
import { ThrottleClickDirective } from '../../directives/throttle-click.directive';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule, ThrottleClickDirective],
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  animations: [
    trigger('backdropAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('modalAnimation', [
      transition(':enter', [
        style({ transform: 'scale(0.9)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'scale(0.9)', opacity: 0 }))
      ])
    ])
  ]
})
export class ConfirmationModalComponent {
  constructor(public confirmationService: ConfirmationService) {}

  onConfirm() {
    const dialog = this.confirmationService.dialogSubject.getValue();
    if (dialog?.onConfirm) {
      dialog.onConfirm();
    }
    this.confirmationService.close();
  }

  onCancel() {
    const dialog = this.confirmationService.dialogSubject.getValue();
    if (dialog?.onCancel) {
      dialog.onCancel();
    }
    this.confirmationService.close();
  }

  getIcon(type?: string): string {
    switch (type) {
      case 'danger': return 'bi-exclamation-triangle-fill';
      case 'warning': return 'bi-exclamation-circle-fill';
      default: return 'bi-question-circle-fill';
    }
  }
}
